export default __webpack_public_path__ + "static/media/SEO.c9dd2f1f.png";